


import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { t } from '../../../../i18n';


interface CashBackTimerProps { scheduled: any; refetchCashback: () => void }

const initialStateTimer = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
}

/**
 * Cashback timer component ( handles refetch of cashback information when frequency turns zero )
 * @returns 
 */
export default function CashBackTimer({ scheduled, refetchCashback }: CashBackTimerProps): React.ReactElement {
    const [timeLeft, setTimeLeft] = useState<typeof initialStateTimer>(initialStateTimer);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);


    const updateTimer = useCallback(() => {
        const now = moment();
        const end = moment(scheduled);
        const duration = moment.duration(end.diff(now));

        if (duration.asMilliseconds() <= 1) {
            timeoutRef.current = setTimeout(() => {
                refetchCashback();
            }, 100)
            return;
        }

        setTimeLeft({
            days: Math.floor(duration.asDays()),
            hours: Math.floor(duration.hours()),
            minutes: Math.floor(duration.minutes()),
            seconds: Math.floor(duration.seconds()),
        });
    }, [timeLeft])

    useEffect(() => {
        updateTimer();
        const intervalId = setInterval(updateTimer, 1000);
        return () => {
            clearInterval(intervalId);
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }
    }, [scheduled])


    return (
        <>
            <CounterSection time={timeLeft.days} text={t("cashback.cashbackCounter.days")} />
            <CounterSeparator />
            <CounterSection time={timeLeft.hours} text={t("cashback.cashbackCounter.hrs")} />
            <CounterSeparator />
            <CounterSection time={timeLeft.minutes} text={t("cashback.cashbackCounter.min")} />
            <CounterSeparator />
            <CounterSection time={timeLeft.seconds} text={t("cashback.cashbackCounter.sec")} />
        </>
    );
}


/**
 * Dots between the counter sections
 * @returns SVG
 */
const CounterSeparator = () => {
    return (
        <span className="timer-dots">
            <svg width="3" height="9" viewBox="0 0 3 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.7">
                    <path d="M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z" fill="#23E78B" />
                    <path d="M1.5 9C2.32843 9 3 8.32843 3 7.5C3 6.67157 2.32843 6 1.5 6C0.671573 6 0 6.67157 0 7.5C0 8.32843 0.671573 9 1.5 9Z" fill="#23E78B" />
                </g>
            </svg>
        </span>
    )
}


/**
 * Each block in ( days, hours, minutes, seconds )
 * @returns Counter section 
 */
const CounterSection = ({ time, text }: { time: number, text: string }) => {
    return (
        <div className="cashback-timer-item ">
            <div className="cachback-timer-item-count nav-link">
                <h3>{time}</h3>
            </div>
            <div className="cachback-timer-item-text">
                <span>{text}</span>
            </div>
        </div>
    )
}